import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomButtonBase } from 'src/components/CustomButtonBase';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const Item = ({ className, item, onClick }) => {
  const styles = useStyles();

  return (
    <CustomButtonBase
      className={cx(className, styles.root)}
      onClick={() => onClick({ name: item.object_name, items: item.data })}
    >
      <CustomTypography
        variant={TYPOGRAPHY_VARIANT.medium14}
        align="left"
      >
        {item.object_name}
      </CustomTypography>
      <CustomTypography
        variant={TYPOGRAPHY_VARIANT.regular12}
        className={styles.type}
      >
        {item.object_type}
      </CustomTypography>
    </CustomButtonBase>
  );
};

Item.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    object_name: PropTypes.string,
    object_type: PropTypes.string,
    data: PropTypes.array,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

Item.defaultProps = {
  className: null,
};
